module.exports = __webpack_public_path__ + "media/images/countryrect/sv-d56d85622b89f5ed66205e0ddc910f8a.svg";